// lon/lat → SVG x/y for charts/us_states.jsx (window.US_MAP, viewBox 959×593).
//
// The lower-48 outlines were drawn with an Albers-USA-style conic equal-area
// projection; the constants below were CALIBRATED EMPIRICALLY against the
// bundled paths (least-squares fit of small-state anchors — DC/RI/DE/CT/NJ —
// then validated with isPointInFill on ~30 well-known cities: 24/27 land
// inside their state; the misses are border-hugging cities like El Paso and
// Detroit, off by a pixel or two). Do not swap in textbook d3.albersUsa
// numbers — this specific SVG is not that exact render.
//
// AK/HI are separate inset panels; cities there are placed with a plain
// linear lon/lat → inset-bbox map (validated: Anchorage/Fairbanks/Juneau,
// Honolulu/Hilo all land inside their outlines). Coarser than a real conic,
// fine for dot placement in insets that small.

(() => {
  const rad = (d) => d * Math.PI / 180;
  // Conic equal-area, parallels 29.5°/45.5°, rotate [96, 0], center [-0.6, 38.7].
  const PHI1 = rad(29.5), PHI2 = rad(45.5);
  const N = (Math.sin(PHI1) + Math.sin(PHI2)) / 2;
  const C = Math.cos(PHI1) ** 2 + 2 * N * Math.sin(PHI1);
  const rho = (phi) => Math.sqrt(Math.max(C - 2 * N * Math.sin(phi), 0)) / N;
  const thC = N * rad(-0.6), rC = rho(rad(38.7));
  const CX = rC * Math.sin(thC), CY = -rC * Math.cos(thC);
  // Fitted screen transform (see header).
  const KX = 1253.24, KY = -1173.17, TX = 473.48, TY = 285.54;

  const lower48 = (lon, lat) => {
    let l = lon + 96;
    l = ((l + 180) % 360 + 360) % 360 - 180;
    const th = N * rad(l), r = rho(rad(lat));
    return [KX * (r * Math.sin(th) - CX) + TX, KY * (-r * Math.cos(th) - CY) + TY];
  };

  // Inset panels: [bbox x, y, w, h] measured from the rendered paths;
  // geographic bounds chosen so the validation cities land inside.
  const linear = (bb, lonW, lonE, latS, latN) => (lon, lat) => [
    bb[0] + (lon - lonW) / (lonE - lonW) * bb[2],
    bb[1] + (latN - lat) / (latN - latS) * bb[3],
  ];
  const alaska = linear([9.8, 432.4, 208.4, 155.7], -168, -130, 54.5, 71.4);
  const hawaii = linear([227.7, 509.8, 112.9, 73.7], -160.3, -154.8, 18.9, 22.25);

  // stateCode routes to the right panel — every caller knows the state.
  window.GEO_PROJECT = (lon, lat, stateCode) => {
    if (stateCode === 'AK') return alaska(lon, lat);
    if (stateCode === 'HI') return hawaii(lon, lat);
    return lower48(lon, lat);
  };

  // Inverse: SVG x/y → [lon, lat] (drop-a-pin search). Inset panels are
  // routed by their bboxes — they overlap the conic's mathematical range,
  // and a click inside the AK/HI boxes means the inset, not Mexico.
  const AK_BB = [9.8, 432.4, 208.4, 155.7];
  const HI_BB = [227.7, 509.8, 112.9, 73.7];
  const inBB = (x, y, bb) => x >= bb[0] && x <= bb[0] + bb[2] && y >= bb[1] && y <= bb[1] + bb[3];
  const linearInv = (bb, lonW, lonE, latS, latN) => (x, y) => [
    lonW + (x - bb[0]) / bb[2] * (lonE - lonW),
    latN - (y - bb[1]) / bb[3] * (latN - latS),
  ];
  const alaskaInv = linearInv(AK_BB, -168, -130, 54.5, 71.4);
  const hawaiiInv = linearInv(HI_BB, -160.3, -154.8, 18.9, 22.25);

  window.GEO_UNPROJECT = (x, y) => {
    if (inBB(x, y, AK_BB)) return alaskaInv(x, y);
    if (inBB(x, y, HI_BB)) return hawaiiInv(x, y);
    const xr = (x - TX) / KX + CX;        // = ρ sinθ
    const yr = -((y - TY) / KY + CY);     // = ρ cosθ
    const r = Math.sqrt(xr * xr + yr * yr);
    const th = Math.atan2(xr, yr);
    const sinphi = (C - (r * N) ** 2) / (2 * N);
    if (sinphi < -1 || sinphi > 1) return null;
    const lon = (th / N) * 180 / Math.PI - 96;
    const lat = Math.asin(sinphi) * 180 / Math.PI;
    if (lon < -180 || lon > -50 || lat < 15 || lat > 75) return null;  // off-map
    return [lon, lat];
  };
})();
